var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: { isOpen: _vm.isOpen },
      on: { "update:isOpen": _vm.handleUpdateIsOpen }
    },
    [
      _c(
        "DialogContent",
        {
          attrs: { title: _vm.title },
          on: { close: _vm.handleCloseButtonClick }
        },
        [_vm._t("default")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }